export let OptionListDirection = /*#__PURE__*/function (OptionListDirection) {
  OptionListDirection[OptionListDirection["VERTICAL"] = 0] = "VERTICAL";
  OptionListDirection[OptionListDirection["HORIZONTAL"] = 1] = "HORIZONTAL";
  return OptionListDirection;
}({});
export let JustifyPosition = /*#__PURE__*/function (JustifyPosition) {
  JustifyPosition[JustifyPosition["START"] = 0] = "START";
  JustifyPosition[JustifyPosition["CENTER"] = 1] = "CENTER";
  JustifyPosition[JustifyPosition["END"] = 2] = "END";
  return JustifyPosition;
}({});